<div class="header animated fadeIn">
    <p>Resumen Financiero del Proyecto</p>
    <img (click)="close()" class="my-auto cursor-pointer" height="13" src="assets/icon/x.svg" alt="close">
</div>

<div class="body fs-body animated fadeIn p-0">
    <div class="d-block m-auto d-sm-flex align-items-sm-center">
        <div class="col-12 col-sm-4 image-s">
            <img [src]="buildImageUrl(project, urlBaseS3)" alt="Image Project" class="w-100">
        </div>
        <div class="col-12 col-sm-7 info-s px-3 py-3">
            <p class="cl-primary fs-24 fw-bold">{{ project.name }}</p>
            <p class="fs-13">Fondeo total: <strong>{{ activePartsTotal | currency: 'MXN' }} <small>MXN</small></strong></p>
            <p class="fs-13">Fondeo aceptado: <strong>{{ resourcesAccepted || 0 | currency: 'MXN' }} <small>MXN</small></strong></p>
            <p class="fs-13">Monto en proceso de fondeo: <strong class="cl-secondary">{{ freePartsTotal || 0 | currency: 'MXN' }} <small>MXN</small></strong></p>
            <p class="fs-13">Recursos disponibles para aceptar: <strong class="cl-secondary">{{ pendingBalance | currency: 'MXN'}} <small>MXN</small></strong></p>

            <div *ngIf="!availableAcceptResources else availableToAccept">
                <button mat-button class="mt-2 mb-1" (click)="acceptResources()" [disabled]="pendingBalance <= 0">
                    {{ pendingBalance <= 0 ? 'Sin recursos disponibles' : 'Solicitar recursos' }}
                </button>
            </div>
            <ng-template #availableToAccept>
                <button mat-button class="mt-2 mb-1" (click)="acceptResources()" [disabled]="pendingBalance <= 0">
                    {{ pendingBalance <= 0 ? 'Sin recursos disponibles' : 'Aceptar recursos' }}
                </button>
            </ng-template>

        </div>
    </div>
</div>
